<template>
  <div class="document-container">
    <!-- <div class="columns"> -->
    <div class="columns is-flex">
      <div
        v-if="systemMessageStatus && hasModule('PRSID:APP:NAV:VIEW')"
        class="column"
      >
        <pid-dash-system-message/>
      </div>
      <div
        v-if="hasModule('PRSID:MATCH:RESOLVENM:VIEW') || hasModule('PRSID:MATCH:HISTORY:VIEW')"
        class="column"
        >
        <pid-dash-pending-work :pendingCounts.sync="pendingCounts"/>
      </div>
      <div
        v-if="hasModule('PRSID:MATCH:OPTIONS:PRSN:ADD')
          || hasModule('PRSID:MATCH:OPTIONS:UPLOADFILE')
          || hasModule('PRSID:SRCH:OPTIONS:PRSN:SRCH')"
        class="column"
      >
      <!-- Use the below class when adding more quick actions to double the width of this column -->
      <!-- class="column double-width" -->
        <pid-dash-quick-actions/>
      </div>
    </div>
    <div
      v-if="hasModule('PRSID:MATCH:HISTORY:VIEW')"
      class="columns"
    >
      <div class="column">
        <pid-dash-recent-activity/>
      </div>
    </div>
    <div
      v-if="hasModule('PRSID:MATCH:RESOLVENM:VIEW')"
      class="columns"
    >
      <div class="column">
        <pid-dash-pending-near-matches :pendingCounts.sync="pendingCounts"/>
      </div>
      <!-- TODO: v2021.x -->
      <!-- <div class="column is-one-quarter">
        <pid-dash-resources/>
      </div> -->
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAbacus,
  faCheckCircle,
} from '@fortawesome/pro-light-svg-icons';
import PidDashPendingNearMatches from '@/components/PidDashPendingNearMatches.vue';
import PidDashPendingWork from '@/components/PidDashPendingWork.vue';
import PidDashQuickActions from '@/components/PidDashQuickActions.vue';
import PidDashRecentActivity from '@/components/PidDashRecentActivity.vue';
import PidDashSystemMessage from '@/components/PidDashSystemMessage.vue';
import BreadcrumbsManager from '@/mixins/BreadcrumbManager';
import FieldLabels from '@/mixins/FieldLabels';
import PermissionManager from '@/mixins/PermissionManager';

library.add(
  faAbacus,
  faCheckCircle,
);

export default {
  mixins: [
    BreadcrumbsManager,
    FieldLabels,
    PermissionManager,
  ],
  components: {
    PidDashPendingNearMatches,
    PidDashPendingWork,
    PidDashQuickActions,
    PidDashRecentActivity,
    PidDashSystemMessage,
  },
  computed: {
    ...mapGetters('propertiesModule', [
      'properties',
    ]),
    systemMessageStatus() {
      return String(this.properties['SYSTEM_MESSAGE-STATUS']).toLowerCase() === 'true';
    },
  },
  data() {
    return {
      pendingCounts: {
        pendingNearMatches: '--',
        pendingBatches: '--',
      },
    };
  },
  async created() {
    await this.onLoad();
    this.setBreadcrumb([
      { text: 'Home', to: {} },
    ]);
  },
  methods: {
    ...mapActions('lookups', [
      'loadPidTransactionStatuses',
      'loadPersonTypes',
    ]),
    async onLoad() {
      try {
        await Promise.all([
          this.loadPidTransactionStatuses(),
          this.loadPersonTypes(),
          this.pendingBatches(),
        ]);
      } catch (err) {
        console.log(err);
      }
    },
    async pendingBatches() {
      const res = await axios.get('personid/batches/pending');
      this.pendingCounts.pendingBatches = res.data;
    },
  },
};
</script>

<style lang="sass" scoped>
.columns.is-flex
  display: flex
  flex-wrap: wrap
  align-items: stretch
.column
  flex: 1
  padding: 0.375rem
.double-width
  flex: 2
</style>
